
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M19 10.5h3.5a1 1 0 011 1v7a1 1 0 01-1 1h-21a1 1 0 01-1-1v-7a1 1 0 011-1H7"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.782 12.547L8.54 13.959l1.414-4.243 8.132-8.131a2 2 0 012.828 2.828zM19.5 5.827l-2.829-2.828M12.782 12.547L9.954 9.716"}}),_c('path',{staticClass:"a",attrs:{"d":"M17.379 2.292a2 2 0 00-2.829 0l-2.121 2.121h-.707M8.54 13.959l-.707.707"}})])
          )
        }
      }
    